import * as Yup from 'yup';
import {  MEDIA_REQUIRED } from '../../../constant/message';

export const stateSchema = Yup.object().shape({
  name: Yup.string().required(MEDIA_REQUIRED),
});
